// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"28522f3b","162":"93cdd8a0","483":"cd52254c","500":"71e45632","580":"d8fe0a94","719":"1f69927d","956":"0b737e78"}[chunkId] + ".chunk.js";
};